module.exports = __webpack_public_path__ + "static/media/shubham_somawanshi.d831edc1.jpg";